import { isStatusRegression } from '@src/utils/requestStatus';
import { actionTypes } from './actions';

export const initialState = {};

const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SYNTHESIS_RESPONSE: {
      const { requestId, audioLink, status, progress, processingAt, endedAt } =
        action;
      if (!requestId) return state;

      const prevRequest = state[requestId];

      // A late IN_PROGRESS message must not undo a finished request. Keep the
      // outcome and only fill in a timestamp the finished record is missing.
      if (prevRequest && isStatusRegression(prevRequest.status, status)) {
        if (prevRequest.processingAt || !processingAt) return state;
        return {
          ...state,
          [requestId]: { ...prevRequest, processingAt },
        };
      }

      // `undefined` means the message did not carry the field, so the previous
      // value stands. `null` is an explicit clear and is written through.
      const keepPrevious = (nextValue, prevValue) =>
        nextValue === undefined ? prevValue : nextValue;

      return {
        ...state,
        [requestId]: {
          ...prevRequest,
          audioLink: keepPrevious(audioLink, prevRequest?.audioLink),
          status: keepPrevious(status, prevRequest?.status),
          progress: keepPrevious(progress, prevRequest?.progress),
          processingAt: processingAt || prevRequest?.processingAt,
          endedAt: endedAt || prevRequest?.endedAt,
        },
      };
    }
    default:
      return state;
  }
};
export default requestReducer;
